module.exports = __webpack_public_path__ + "static/img/icon-share.f613e891.png";